module.exports = __webpack_public_path__ + "static/media/Challenges-in-migration-from-SAP-to-Workday.7f2a6ec3.png";